<template>
  <div class="contract-peform-detail">
    <common-header />
    <div class="width-1260">
      <el-breadcrumb>
        <el-breadcrumb-item :to="{ path: '/' }"
          >平方区域联采</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/mineProject' }"
          >我的联采项目</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/jointPlan' }"
          >联采方案列表</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/jointPlan/detail', params: '123' }"
          >查看联采方案</el-breadcrumb-item
        >
        <el-breadcrumb-item>{{ renderDom.breadcrumb }}</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="white-container">
        <div class="title">
          {{ renderDom.title }}
        </div>
        <!-- 方案详情 -->
        <el-form
          :rules="renderDom.formRules"
          ref="detailDataRef"
          :model="detailData"
        >
          <div class="form-flex">
            <el-form-item
              label="标包"
              label-width="80px"
              v-if="routeParams.type === '1'"
            >
              <el-input
                readonly
                :style="{ width: '455px' }"
                v-model="detailData.bidPackageName"
              />
            </el-form-item>
            <el-form-item
              label="中标结果"
              label-width="80px"
              v-if="routeParams.type === '1'"
            >
              <el-input
                readonly
                :style="{ width: '455px' }"
                v-model="detailData.lcPurchasePlanName"
              />
            </el-form-item>
            <div v-for="(item, cIndex) in renderDom.formList" :key="cIndex">
              <el-form-item
                :label="item.name"
                :prop="item.key"
                :label-width="item.labelWidth ? item.labelWidth : '80px'"
              >
                <el-input
                  v-if="item.key === 'remarks'"
                  type="textarea"
                  :rows="3"
                  :style="{ width: item.width }"
                  v-model="detailData[item.key]"
                  :placeholder="item.placeholder"
                />
                <div class="width-455px" v-else-if="item.type === 'attachment'">
                  <template v-if="Array.isArray(detailData[item.key])">
                    <div v-if="routeParams.type === '4'">
                      <el-upload
                        v-model:file-list="detailData[item.key]"
                        :action="projectDocUploadUrl"
                        with-credentials
                        :on-preview="priviewFile"
                        accept=".jpg, .PNG, .png, .jpeg, .pdf, .xls, .xlsx"
                        :on-success="
                          (res, file, files) =>
                            uploadSuccess(res, file, files, item.key)
                        "
                        :on-remove="(file, files) => removeFile(files)"
                        multiple
                        name="files"
                        :data="{ fileType: item.fileType }"
                      >
                        <el-button type="primary">点击上传</el-button>
                      </el-upload>
                    </div>
                  </template>
                </div>
                <el-select
                  v-else-if="item.type === 'select'"
                  v-model="detailData[item.key]"
                  :multiple="item.multiple"
                  clearable
                  class="width-455"
                  :placeholder="item.placeholder"
                  @change="
                    (e) => item.key === 'lcContractId' && selectContract(e)
                  "
                >
                  <el-option
                    v-for="item in selectOptions[item.key]"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
                <el-radio-group
                  v-else-if="item.type === 'radio'"
                  v-model="detailData[item.key]"
                  :style="{ width: '455px' }"
                >
                  <el-radio :label="1">
                    <span v-if="routeParams.type === '4'"> 线下支付 </span>
                    <span v-else> 固定价 </span>
                  </el-radio>
                  <el-radio :label="2">
                    <span v-if="routeParams.type === '4'"> 金融支付 </span>
                    <span v-else> 浮动价 </span>
                  </el-radio>
                </el-radio-group>
                <el-date-picker
                  v-else-if="item.type === 'date'"
                  style="width: 455px"
                  format="YYYY/MM/DD"
                  value-format="YYYY-MM-DD"
                  clearable
                  v-model="detailData[item.key]"
                  type="date"
                />
                <el-date-picker
                  v-else-if="item.type === 'dateRange'"
                  style="width: 455px"
                  format="YYYY/MM/DD"
                  value-format="YYYY-MM-DD"
                  v-model="detailData.dataRange"
                  type="daterange"
                  @change="handleChangeDate"
                />
                <el-input-number
                  class="text-align-start"
                  v-else-if="item.type === 'number'"
                  v-model="detailData[item.key]"
                  :style="{ width: '455px' }"
                  :min="0"
                  clearable
                  :controls="false"
                />
                <el-input
                  v-else-if="item.type === 'modal'"
                  @click="openModalOrder"
                  readonly
                  :style="{ width: '455px' }"
                  v-model="detailData[item.key]"
                />
                <el-input
                  v-else
                  :disabled="item.disabled"
                  clearable
                  :readonly="item.readonly"
                  :style="{ width: '455px' }"
                  v-model="detailData[item.key]"
                />
              </el-form-item>
            </div>
          </div>
        </el-form>
        <!-- 方案表格 -->
        <div
          class="table-container"
          v-for="(columnItem, index) in renderDom.columns"
          :key="index"
        >
          <div class="s-title" v-if="columnItem.columnsName">
            <div class="blue-common-title">{{ columnItem.columnsName }}</div>
            <div class="btn-container">
              <el-button
                v-if="columnItem.exportBtn"
                @click="handleDownloadFile"
              >
                <el-icon class="icon icon-xiazai3"></el-icon
                >导出材料清单</el-button
              >
              <el-button
                v-if="columnItem.downloadBtn"
                @click="downloadMaterialTemplate"
              >
                <el-icon class="icon icon-xiazai3"></el-icon
                >下载清单模板</el-button
              >
              <el-upload
                v-if="columnItem.uploadBtn"
                v-model:file-list="fileList"
                class="upload-btn"
                accept=".xls, .xlsx"
                :action="columnItem.uploadObject.action"
                :on-success="uploadMaterialFileSuccess"
                :on-progress="uploadMaterialFileProgress"
                :with-credentials="true"
                :show-file-list="false"
                :data="{
                  [columnItem.uploadObject.key]:
                    detailData[columnItem.uploadObject.key] || routeParams.id,
                }"
                :disabled="routeParams.type === '2' && !detailData.lcContractId"
              >
                <el-button>
                  <el-icon class="icon icon-shangchuan2"></el-icon
                  >导入材料清单</el-button
                >
              </el-upload>

              <el-button
                v-if="columnItem.addNewBtn"
                @click="() => setTableEditRow()"
                :disabled="
                  (routeParams.type === '2' && !detailData.lcContractId) ||
                  editTableIndex !== -1
                "
              >
                <el-icon class="icon icon-jia1"></el-icon>新增材料</el-button
              >
              <el-button
                v-if="columnItem.addNewAcceptanceBtn"
                @click="openAcceptanceModal"
              >
                <el-icon class="icon icon-jia1"></el-icon>新增验收单</el-button
              >
            </div>
          </div>
          <div
            class="acceptance-list-tabs"
            v-if="columnItem.acceptanceTabs && acceptanceTabsList.length"
          >
            <div
              class="tab-item"
              v-for="(item, index) in acceptanceTabsList"
              :class="currentAcceptanceId === item.id ? 'tab-active' : ''"
              :key="item.id"
            >
              <span class="cursor-pointer" @click="changeAcceptanceId(item.id)">
                {{ item.acceptNo }}
              </span>
              <el-icon
                @click="deleteAcceptanceTab(index)"
                class="margin-left-6 cursor-pointer font-s-16"
                ><Close
              /></el-icon>
            </div>
          </div>
          <el-form
            ref="editTabeRef"
            :model="editTableData"
            :rules="columnItem.formRules"
          >
            <el-table
              border
              :header-cell-style="{
                backgroundColor: '#F2F3F5',
                color: '#1D2129',
              }"
              :row-style="{ height: '60px' }"
              tooltip-effect="light"
              :data="detailData[columnItem.key]"
            >
              <template
                v-for="(item, index) in columnItem.columns"
                :key="index"
              >
                <el-table-column
                  v-if="item.key === 'number'"
                  :prop="item.prop"
                  :label="item.name"
                  align="center"
                  :width="80"
                >
                  <template #default="scope">
                    <span
                      v-if="
                        editTableIndex === scope.$index && scope.$index === 0
                      "
                    >
                      1
                    </span>
                    <span v-else>
                      {{ scope.row.number ? scope.row.number : scope.$index }}
                    </span>
                  </template>
                </el-table-column>
                <el-table-column
                  v-else-if="item.key === 'acceptStatus'"
                  :prop="item.prop"
                  :label="item.name"
                  align="center"
                  :min-width="120"
                >
                  <template #default="scope">
                    {{ acceptStatusDic[scope.row.acceptStatus] }}
                  </template>
                </el-table-column>
                <el-table-column
                  v-else-if="item.key === 'acceptanceForm'"
                  :prop="item.prop"
                  :label="item.name"
                  align="center"
                  :min-width="120"
                >
                  <template #default="scope">
                    <a
                      v-for="(item, index) in scope.row.acceptanceForm"
                      :key="index"
                      :href="item.path"
                      >{{ item.name }}</a
                    >
                  </template>
                </el-table-column>
                <el-table-column
                  v-else-if="item.key === 'operate'"
                  :prop="item.prop"
                  :label="item.name"
                  align="center"
                  :min-width="120"
                >
                  <template #default="scope">
                    <template v-if="scope.row.number !== '合计'">
                      <template v-if="editTableIndex === scope.$index">
                        <el-button :link="true" @click="handleSaveTableEditRow"
                          >保存</el-button
                        >
                        |
                        <el-button
                          class="margin-left-0"
                          :link="true"
                          @click="cancelEditRow(scope.$index)"
                          >取消</el-button
                        >
                      </template>
                      <template v-else>
                        <el-button
                          :link="true"
                          @click="setTableEditRow(scope.$index, scope.row)"
                          >编辑</el-button
                        >
                        |
                        <el-button
                          class="margin-left-0"
                          :link="true"
                          @click="handleDeleteMaterial(scope.row.id)"
                          >删除</el-button
                        >
                      </template>
                    </template>
                  </template>
                </el-table-column>
                <el-table-column
                  v-else
                  :label="item.name"
                  align="center"
                  show-overflow-tooltip
                  :min-width="120"
                >
                  <template #default="scope">
                    <el-form-item
                      v-if="editTableIndex === scope.$index"
                      :key="index"
                      :prop="item.key"
                    >
                      <span v-if="item.key === 'taxTotalPrice'">{{
                        editTableData[item.key]
                      }}</span>
                      <el-input-number
                        v-else-if="item.type === 'number'"
                        v-model="editTableData[item.key]"
                        :min="0"
                        :controls="false"
                      />
                      <el-input v-else v-model="editTableData[item.key]" />
                    </el-form-item>
                    <span v-else>
                      {{ scope.row[item.key] }}
                    </span>
                  </template>
                </el-table-column>
              </template>
            </el-table>
          </el-form>
        </div>
        <div class="text-align-center">
          <el-button @click="goListPage">返回</el-button>
          <el-button type="primary" @click="handleCommitData">保存</el-button>
        </div>
      </div>
    </div>
    <common-footer />
    <!-- 合同弹窗 -->
    <el-dialog
      title="新建合同"
      width="700px"
      v-model="newContractModal"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      destroy-on-close
      :show-close="false"
    >
      <el-form
        ref="newContractRef"
        :model="newContractData"
        :rules="newContractRules"
        label-width="120px"
      >
        <el-form-item label="选择标包" prop="bidPackage">
          <el-select
            v-model="newContractData.bidPackage"
            class="width-455px"
            placeholder="请选择标包"
            @change="getBidWinningList"
          >
            <el-option
              v-for="item in selectBidList"
              :key="item.id"
              :label="item.name + ' - ' + item.bidName"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="选择中标结果" prop="bidResultId">
          <el-select
            v-model="newContractData.bidResultId"
            :disabled="!newContractData.bidPackage"
            class="width-455px"
            placeholder="请选择中标结果"
          >
            <el-option
              v-for="item in bidResultList"
              :key="item.id"
              :label="item.lcPurchasePlanName"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="goListPage">返回</el-button>
          <el-button type="primary" @click="handleNextStep"> 下一步 </el-button>
        </span>
      </template>
    </el-dialog>
    <!-- 订单弹窗 -->
    <el-dialog
      title="选择订单"
      width="1200px"
      v-model="orderModal"
      destroy-on-close
      :close-on-click-modal="false"
      @close="closeOrderModal"
    >
      <el-form>
        <div class="d-flex-space-b">
          <el-form-item label="供应单位" prop="supplierEnterpriseName">
            <el-input
              v-model="orderParams.supplierEnterpriseName"
              placeholder="供应商单位名称"
              clearable
              class="width-380"
            ></el-input>
          </el-form-item>
          <el-button type="primary" @click="getOrderlist">搜索</el-button>
        </div>
      </el-form>
      <el-table
        v-if="orderModal"
        border
        :header-cell-style="{
          backgroundColor: '#F2F3F5',
          color: '#1D2129',
        }"
        :row-style="{ height: '60px' }"
        tooltip-effect="light"
        :data="orderList"
      >
        <el-table-column
          v-for="(item, index) in orderColumns"
          :key="index"
          :label="item.name"
          :prop="item.key"
          align="center"
        >
          <template #default="scope">
            <span v-if="item.key === 'orderStatus'">
              {{
                orderStatusDic.find(
                  (item) => item.value === scope.row.orderStatus
                ).label
              }}
            </span>
            <span
              v-else-if="item.key === 'operate'"
              class="primary-color cursor-pointer"
              @click="() => modalSelectOrder(scope.row)"
              >选择此订单</span
            >
            <span v-else>{{ scope.row[item.key] }}</span>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <!-- 验收单弹窗 -->
    <el-dialog
      title="新增验收单"
      width="1200px"
      v-model="acceptanceModal"
      destroy-on-close
      :close-on-click-modal="false"
      @close="closeOrderModal"
    >
      <el-form label-width="100px" :model="acceptanceParams">
        <div class="d-flex-wrap">
          <el-form-item label="合同名称" prop="contractName">
            <el-input
              v-model="acceptanceParams.contractName"
              placeholder="供应商合同名称"
              clearable
              class="width-380"
            ></el-input>
          </el-form-item>
          <el-form-item label="供应单位" prop="supplierEnterpriseName">
            <el-input
              v-model="acceptanceParams.supplierEnterpriseName"
              placeholder="供应商单位名称"
              clearable
              class="width-380"
            ></el-input>
          </el-form-item>
          <el-form-item label="状态" prop="acceptStatus">
            <el-select
              v-model="acceptanceParams.acceptStatus"
              placeholder="选择状态"
              class="width-380"
            >
              <el-option
                v-for="item in acceptanceStatusDic"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-button type="primary" class="margin-l-auto" @click="getAcceptList"
            >搜索</el-button
          >
        </div></el-form
      >
      <el-table
        v-if="acceptanceModal"
        border
        :header-cell-style="{
          backgroundColor: '#F2F3F5',
          color: '#1D2129',
        }"
        :row-style="{ height: '60px' }"
        tooltip-effect="light"
        :data="acceptanceList"
      >
        <el-table-column
          v-for="(item, index) in acceptanceColunms"
          :key="index"
          :label="item.name"
          :prop="item.key"
          align="center"
        >
          <template #default="scope">
            <span v-if="item.key === 'acceptStatus'">
              {{
                acceptanceStatusDic.find(
                  (item) => item.value === scope.row.acceptStatus
                ).label
              }}
            </span>
            <span
              v-else-if="item.key === 'operate'"
              class="primary-color cursor-pointer"
              @click="() => selectAcceptance(scope.row)"
              >选择此验收单</span
            >
            <span v-else>{{ scope.row[item.key] }}</span>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>
<script>
module.exports = require("./index");
</script>
<style lang="scss">
@import "./index.scss";
</style>
